import { useEffect } from "react";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import TrustBar from "@/components/sections/TrustBar";
import Services from "@/components/sections/Services";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import Gallery from "@/components/sections/Gallery";
import PromoHighlight from "@/components/sections/PromoHighlight";
import OrderingProcess from "@/components/sections/OrderingProcess";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import CTAFooter from "@/components/sections/CTAFooter";
import { siteConfig, waLink } from "@/lib/siteConfig";
import { MessageCircle } from "lucide-react";

export default function LandingPage() {
  useEffect(() => {
    document.title = `${siteConfig.brandName} — ${siteConfig.tagline}`;
  }, []);

  return (
    <main data-testid="landing-page" className="bg-background min-h-screen">
      <Header />
      <Hero />
      <TrustBar />
      <Services />
      <WhyChooseUs />
      <Gallery />
      <PromoHighlight />
      <OrderingProcess />
      <Testimonials />
      <FAQ />
      <CTAFooter />

      {/* Floating WA button (mobile) */}
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        className="fixed bottom-5 right-5 z-50 sm:hidden bg-[#C97A4E] hover:bg-[#B86A3F] text-white rounded-full p-4 shadow-xl transition-transform hover:scale-105"
        aria-label="Hubungi via WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </main>
  );
}
